"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1({ settlementRequestType, settlementRequestData, inputData, commissionOrderId, }) {
    const isPaymentRequest = settlementRequestType === 'payment';
    const isWithdrawRequest = settlementRequestType === 'withdraw';
    const isCommissionWithdraw = settlementRequestType === 'commission';
    const { settlement_bank, settlement_account, request_amount, proof_files, tax_type } = inputData;
    const updates = {
        bank: settlement_bank,
        account: settlement_account === null || settlement_account === void 0 ? void 0 : settlement_account.replace(/-/g, ''),
        amount: request_amount,
        images: Array.from(proof_files || []).map(file => file.media_id),
        tax_type: tax_type !== null && tax_type !== void 0 ? tax_type : 0,
    };
    const { possible_amount, total_withdrawable_amount, total_reward_amount, room_status_cd_id } = settlementRequestData;
    const isBuyerInfoDiscarded = room_status_cd_id === 'ROOM_STATUS_06';
    const isRewardKeep = isWithdrawRequest &&
        possible_amount === 0 &&
        total_withdrawable_amount === 0 &&
        Boolean(total_reward_amount) &&
        isBuyerInfoDiscarded;
    !isPaymentRequest && Object.assign(updates, { is_reward: isRewardKeep ? true : false });
    isCommissionWithdraw && Object.assign(updates, { order_id: commissionOrderId });
    return updates;
}
exports.default = default_1;
